<template>
  <el-card>
    <div
        slot="header"
        class="clearfix">
      <span class="header-item">{{ $t('device_ownership.title') }}</span>
      <span :class="{'ring-card__header-buttons': true, 'disable-html': loading }">
        <RefreshButton @click.native="getDeviceOwnership()" />
      </span>
    </div>
    <div
        v-loading="loading"
        class="card-content">
      <el-table
          :data="device_ownership"
          class="device-ownership-table"
          style="width: 100%"
          max-height="500">
        <el-table-column label="Product Name">
          <template slot-scope="scope">
            {{ findProduct(scope.row).description | capitalize }}
          </template>
        </el-table-column>
        <el-table-column label="Name">
          <template slot-scope="scope">
            {{ scope.row.name }}
          </template>
        </el-table-column>
        <el-table-column label="Device ID">
          <template slot-scope="scope">
            {{ scope.row.mac_address }}
          </template>
        </el-table-column>
        <el-table-column label="Owner">
          <template slot-scope="scope">
            <span :style="{ color: isCustomerLastOwner(scope.row) ? '' : 'red' }">
              {{ isCustomerLastOwner(scope.row) ? customer.email : 'Unknown' }}
            </span>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </el-card>
</template>

<script>
import { createNamespacedHelpers as h } from "vuex";
import RefreshButton from "@/containers/Customer/RefreshButton";
const { mapActions, mapGetters } = h("db/account");
const { mapGetters: sharedGetters } = h("shared");
export default {
  name: "DeviceOwnership",
  components: {
    RefreshButton,
  },
  data() {
    return {
      loading: false,
      error: {
        value: false,
        message: "Failed to load Device Ownership",
      },
      device_ownership: [],
    };
  },
  computed: {
    ...mapGetters(["customerId", "customer"]),
    ...sharedGetters(["products"]),
  },
  created() {
    this.getDeviceOwnership();
  },
  methods: {
    ...mapActions(["fetchDeviceOwnership"]),
    findProduct(dh) {
      let p = this.products.find((p) => {
        return p.kind === dh.type;
      });
      return p || {};
    },
    isCustomerLastOwner(dh) {
      return dh.owner_id === this.customerId;
    },
    getDeviceOwnership() {
      this.loading = true;
      this.fetchDeviceOwnership({ customerId: this.customerId })
        .then((response) => {
          console.log(response);
          this.device_ownership = response.device_history;
        })
        .catch((error) => {
          console.log("Error: ", error);
          this.$notify({
            title: "Device History",
            message: h(
              "i",
              { class: { "update-setting_error_msg": true } },
              "No device history found"
            ),
            duration: 0,
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style lang="scss">
.device-ownership-table {
  .user-email {
    display: block;
    color: $--color-curious-blue;
  }
}
</style>
